// @ts-nocheck
import * as React from "react";
import { IconOffset } from "@toolkit/Framework/Types/Icon";

const Close: React.FC = () => {
    return (
        /* Store Custom Code - Start */
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <path
                fill="currentColor"
                d="M6.4 18.308 5.69 17.6l5.6-5.6-5.6-5.6.708-.708 5.6 5.6 5.6-5.6.708.708-5.6 5.6 5.6 5.6-.708.708-5.6-5.6-5.6 5.6Z"
            />
        </svg>
        /* Store Custom Code - End */
    );
};

export const CloseOffset: IconOffset = {
    vertical: 0, // Store Custom Code
    horizontal: 0, // Store Custom Code
};

export default React.memo(Close);
